/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddUserModel
 */
export interface AddUserModel {
    /**
     * 
     * @type {string}
     * @memberof AddUserModel
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddUserModel
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddUserModel
     */
    password: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddUserModel
     */
    userRoles?: Array<string> | null;
}

/**
 * Check if a given object implements the AddUserModel interface.
 */
export function instanceOfAddUserModel(value: object): value is AddUserModel {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function AddUserModelFromJSON(json: any): AddUserModel {
    return AddUserModelFromJSONTyped(json, false);
}

export function AddUserModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUserModel {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'password': json['password'],
        'userRoles': json['userRoles'] == null ? undefined : json['userRoles'],
    };
}

export function AddUserModelToJSON(json: any): AddUserModel {
    return AddUserModelToJSONTyped(json, false);
}

export function AddUserModelToJSONTyped(value?: AddUserModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'password': value['password'],
        'userRoles': value['userRoles'],
    };
}

